import moment from 'moment';
// Форматы дат лежат src\config\formats.js

export default (date, format) => {
  if (date && format) {
    return moment(date).format(format);
  }
  return 'нет даты';
};
